<template>
  <div>
    <div class="page-back" v-if="!isExamMode">
      <i class="el-icon-arrow-left" @click="goBack()"
        ><span class="desc">{{ $t('mark_back') }}</span></i
      >
    </div>
    <Progress-simulation
      v-if="resourceList.length"
      :selectList="resourceList"
      @currentSelect="currentSelect($event)"
      @play="playAudio"
      @pause="pauseAudio"
      @stop="playStop"
      @submitAnswer="submitAnswer"
      @changeTime="changeTime"
      :title="filterPaperName(titleTrans)"
      ref="progress"
      :answerObject="answerObject"
      :answerNotesArray="answerNotesArray"
      :showButtonPlay="showButtonPlay"
      :showButtonPause="showButtonPause"
      :time="time"
      :isShowCountDown="isShowCountDown"
      :playVoiceTime="playVoiceTime"
      :isExamMode="isExamMode"
      :listenNumList="listenNumList"
      :partProgressList="partProgressList"
      :isMarked="isMarked"
      :markIdList="markIdList"
      :examinationId="examId"
      :isPlaying="isPlaying"
      @progressStatus="changeProgressStatus($event)"
    >
      <div slot="content">
        <!-- 既兼容新资源格式还要兼容老资源格式 -->
        <component
          :is="currentHSKComponent"
          :currItem="currItem"
          :jsonData="currItem"
          :isExamMode="isExamMode"
          :isShowAnAnalysis="!isExamMode"
          :leftTime="time"
          @saveRes="saveRes($event)"
          :writeIsBegin="writeIsBegin"
          ref="componentRef"
          :key="`${currItem.count}_${randomData}`"
          :ansProgressStatus="ansProgressStatus"
          :baseUrl="rootPath"
          :isMarked="isMarked"
        >
        </component>
      </div>
    </Progress-simulation>
  </div>
</template>

<script>
import ProgressSimulation from '@/components/hsk/progressSimulation.vue'
import Judgment from '@/components/hsk/judgment'
import SelectPicByVoice from '@/components/hsk/selectPicByVoice'
import SelectTextByVoice from '@/components/hsk/selectTextByVoice'
import SelectSentenceByVoice from '@/components/hsk/selectSentenceByVoice'
import SetChoosePicByText from '@/components/hsk/setChoosePicByText'
import SetChoosePicByVoiceSimulation from '@/components/hsk/setChoosePicByVoiceSimulation'
import SetChooseTextByText from '@/components/hsk/setChooseTextByText'
import JoinSentence from '@/components/hsk/joinSentence'
import FillInBlank from '@/components/hsk/fillInBlank'
import ReadingOrder from '@/components/hsk/readingOrder'
import setChooseTextByVoiceSimulation from '@/components/hsk/setChooseTextByVoiceSimulation'
import SetReadChooseTextBySentence from '@/components/hsk/setReadChooseTextBySentence'
import SetReadChooseTextFillBlank from '@/components/hsk/setReadChooseTextFillBlank'
import SelectTextReadingComprehension from '@/components/hsk/selectTextReadingComprehension'
import abbreviationSimulation from '@/components/hsk/abbreviationSimulation'
import MakeSentence from '@/components/hsk/makeSentence'
import { HSK_SIMULATION_COMPONENTS, MARK_RESULT_TYPE, VOICE_EXTEND_TIME } from '@/config'
import { backLayerHandler, getQueryString, changeURLArg } from '@/utils/utils'
import { getToken } from '@/utils/cache'
import ApiPath from '@/serves/path'
import analytics from '@/utils/AnalyticsCenter'
// import lifecycle from 'page-lifecycle'
export default {
  components: {
    ProgressSimulation,
    Judgment,
    SelectPicByVoice,
    SelectTextByVoice,
    SelectSentenceByVoice,
    SetChoosePicByText,
    SetChoosePicByVoiceSimulation,
    SetChooseTextByText,
    JoinSentence,
    FillInBlank,
    ReadingOrder,
    setChooseTextByVoiceSimulation,
    SetReadChooseTextBySentence,
    SetReadChooseTextFillBlank,
    SelectTextReadingComprehension,
    MakeSentence,
    abbreviationSimulation,
  },
  data() {
    return {
      // 组装后的整套试卷数据
      resourceList: [],
      // 当前选中题型的全部信息
      currItem: {},
      // 用户选择的答案数据
      answerObject: {},
      // dialogVisible: false,
      time: -1, // 倒计时时间
      //是否显示播放按钮
      showButtonPlay: true,
      showButtonPause: false,
      // 是否第一个未作答的题
      isFirstQuestion: false,
      // 作答记录数组
      answerNotesArray: [],
      // 是否显示倒计时（答题模式听力环节和阅卷模式不显示）
      isShowCountDown: true,
      // 是否提交了答案
      isSubmitAnswer: false,
      // 试卷名称的多语言
      titleTrans: {},
      paperType: '', // 当前语言下的试卷名称
      // 音频总时长
      playVoiceTime: '',
      // 环节流程数组
      partProgressList: [],
      // 听力回顾音频
      explainAudio: '',
      // 记录听力音频那些播放过
      videoPlayList: [],
      // 听力每题音频携带音频音频数量数组
      listenNumList: [],
      // 书写题是否开始
      writeIsBegin: 0,
      // 当前环节所处的阶段 0 预览 1 作答 2 回顾
      ansProgressStatus: 0,
      randomData: '',
      examination_id: '',
      // 资源根路径
      rootPath: '',
      // 试卷是否下架
      paperOff: false,
      // 是否批改
      isMarked: 2, // 0 未批改 1批改中 2已批改
      markIdList: [], // 需要批改的题ID
      // 等级类型和名称 eg：hsk5
      examType: '',
      // 保存一下考试的 examination_id
      examId: '',
      // 音频控件是否暂停，用于耳机插拔场景
      playerPaused: false,
      // 点击了退出登录
      onClickLogout: false,
      // 考试里面所有的听力合集
      listenAllList: [],
      isPlaying: false,
    }
  },
  computed: {
    //当前题型组件
    currentHSKComponent() {
      let component = HSK_SIMULATION_COMPONENTS[this.currItem.topic_type]
      console.log('component', component)
      console.log('this.currItem', this.currItem)
      return component
    },
    //是否是答题模式
    isExamMode() {
      return !(this.$route.query.paperStatus == 1)
    },
    isLogin() {
      return this.$store.state.user.login
    },
  },

  async mounted() {
    this.pageInitPlayerSetting()
    await this.getPaperDetails()
    await this.getQuesList()
    /**
     * 监听页面刷新或关闭事件
     */
    const that = this
    // lifecycle.addEventListener('statechange', async function (event) {
    //   console.log(33333333333333333333333333)
    //   console.log(event.oldState, event.newState)
    //   if (event.oldState == 'hidden' && event.newState == 'terminated') {
    //     console.log('刷新页面')
    //     sessionStorage.setItem('onbeforeunload', 'simulation')
    //     localStorage.removeItem('bigIndex')
    //     let status = that.$refs.progress.ansProgressStatus != 2
    //     // that.$refs.progress.$refs.countDown.pause();
    //     await that.$refs.progress.saveApiRequest('', status)
    //   }
    // })
    // window.addEventListener('pagehide', async (e) => {
    //   console.log(22222222222222222222222111111111111111111111)
    //   console.warn('pagehide')
    //   sessionStorage.setItem('onbeforeunload', 'simulation')
    //   localStorage.removeItem('bigIndex')
    //   let status = that.$refs.progress.ansProgressStatus != 2
    //   // that.$refs.progress.$refs.countDown.pause();
    //   await that.$refs.progress.saveApiRequest('', status)
    //   e.stopPropagation()
    //   return ''
    //   // alert('pagehide')
    // })
    window.onbeforeunload = async () => {
      // 关闭浏览器保存答题结果
      // that.playStop();
      // 刷新或者离开埋点
      analytics.logEvent('hskweb_mockClick_beforeunload', {
        url: location.href,
      })
      sessionStorage.setItem('onbeforeunload', 'simulation')
      localStorage.removeItem('bigIndex')
      let status = that.$refs.progress.ansProgressStatus != 2
      // that.$refs.progress.$refs.countDown.pause();
      this.$store.dispatch('notifLogout', false)
      await that.$refs.progress.saveApiRequest('', status)
      return ''
    }
    // document.addEventListener('visibilitychange', () => {
    //   if (document.hidden) {
    //     // 页面切换到后台
    //     this.$player.pause()
    //     alert('页面切换到后台');
    //   } else {
    //     // 页面切换到前台
    //     let audioPath = this.rootPath + this.currItem.content;
    //     alert(audioPath)
    //     this.$player.play(audioPath, "", {});
    //     alert('页面切换到前台');
    //   }
    // });
    window.addEventListener('HSKVoice', () => {
      that.isExamMode && that.changeIndex()
    })
    /**
     * 监听音频设备的变化保证插拔耳机音频播放不影响
     */
    try {
      navigator.mediaDevices.ondevicechange = () => {
        try {
          navigator.mediaDevices.enumerateDevices().then((devices) => {
            // 非听力环节或者听力回顾环节不处理
            const ansProgressStatus = +this.$refs.progress.ansProgressStatus
            if (this.currItem.segment_code !== 'listen' || ansProgressStatus === 2) return
            // 检查是否有音频设备
            var hasAudioInput = devices.some((device) => {
              return device.kind === 'audioinput' && device.deviceId !== 'default'
            })
            // 暂停播放
            if (!hasAudioInput) {
              this.$player.pause()
              this.playerPaused = true
              this.$store.dispatch('setPartForAudio', {
                isPaused: this.playerPaused,
              })
              console.log('Audio output device disconnected. Audio paused.')
            } else {
              // 继续播放
              // 如果是听力预览环节并且是非暂停状态，则播放预览音频
              if (ansProgressStatus === 0) {
                // 如果是非暂停代表是首次进入页面连接音频设备无须处理
                if (!this.playerPaused) return
                this.$player.play(this.explainAudio)
              } else {
                // 听力正式环节播放当前音频
                const voiceIndex = this.$refs.progress && this.$refs.progress.currentVoiceIndex
                const voiceItem = this.listenAllList[voiceIndex - 1]
                let audioPath = this.rootPath + voiceItem.audio_url
                console.log('audioPath', audioPath)
                this.$player.play(audioPath)
              }
              this.playerPaused = false
              this.$store.dispatch('setPartForAudio', {
                isPaused: this.playerPaused,
              })
              console.log('Audio device connected. Audio play.')
            }
          })
        } catch (error) {
          console.error('Error in ondevicechange event:', error)
        }
      }
    } catch (error) {
      console.log('error in navigator.mediaDevices', error)
    }
  },
  watch: {
    // 监听当前题变了,播放状态按钮禁用,只有同一个题才播放状态(当前语音播放的题跟 答题卡上选中的题)
    currItem: {
      handler(newVal) {
        console.log('currItem------', newVal)
        let isListenGroup =
          newVal.topic_type == 'ea' &&
          newVal.questions.find((item) => item.listen && item.listen.audio_file)
        if (
          newVal.segment_code == 'listen' &&
          newVal.topic_type != 'xt' &&
          newVal.topic_type != 'lt' &&
          !isListenGroup
        ) {
          if (
            this.$refs.progress.currentVoiceIndex == this.$refs.progress.currentQuesIndex &&
            this.$refs.progress.ansProgressStatus == 1
          ) {
            this.showButtonPlay = false
            this.showButtonPause = true
          } else {
            this.showButtonPlay = true
            this.showButtonPause = false
          }
        } else {
          this.ansProgressStatus = this.$refs.progress.ansProgressStatus
          this.showButtonPlay = false
          this.showButtonPause = false
        }
      },
      deep: true,
    },
    // 当前题型组件
    currentHSKComponent(val, oldVal) {
      // 埋点-组件切换
      analytics.logEvent('hskweb_mockflow_part', {
        prevPart: oldVal || '',
        part: val,
      })
    },
    '$store.state.simulation.beforeLogout': function (val) {
      console.log('考试过程中点击退出登录')
      if (val) {
        this.$router.push('/')
        this.onClickLogout = true
      }
    },
  },
  methods: {
    pageInitPlayerSetting() {
      try {
        this.$player.onloaderrored = () => {
          console.log('get loadError')
          const _this = this
          layer.open({
            title: '',
            closeBtn: 0,
            content: _this.$t('hsk_audio_error'),
            btn: [_this.$t('button_common_start_over'), _this.$t('hsk_skip')],
            yes: (index) => {
              window.location.reload()
              layer.close(index)
            },
            btn2: (index) => {
              layer.close(index)
            },
          })
        }
        this.$player.onplayerrored = () => {
          console.log('get loadError')
          const _this = this
          layer.open({
            title: '',
            closeBtn: 0,
            content: _this.$t('hsk_audio_error'),
            btn: [_this.$t('button_common_start_over'), _this.$t('hsk_skip')],
            yes: (index) => {
              window.location.reload()
              layer.close(index)
            },
            btn2: (index) => {
              layer.close(index)
            },
          })
        }
        this.watchMethods(this.$player, (m, v) => {
          if (m == 'setPlayClass') {
            if (v.length > 0 && v[0] == 'play') {
              this.isPlaying = true
            } else {
              this.isPlaying = false
            }
          }
        })
      } catch (error) {
        console.log(error)
      }
    },
    setPlayingState(v) {
      if (v.length > 0 && v[0] == 'play') {
        this.isPlaying = true
      } else {
        this.isPlaying = false
      }
    },
    playerErrorNotice() {},
    watchMethods(o, callback) {
      const methods = Object.getOwnPropertyNames(Object.getPrototypeOf(o))
      methods.forEach((method) => {
        if (typeof o[method] === 'function' && method !== 'constructor') {
          const fn = o[method]
          o[method] = (...args) => {
            callback && callback(method, args)
            return fn.apply(o, args)
          }
        }
      })
    },
    // 获取试卷总时长等信息，组装数据
    getPaperDetails() {
      return new Promise((resolve) => {
        utilV2.postData(
          ApiPath.hsk_paper_repare,
          {
            paperId: this.$route.query.paperId,
            examinationType: this.$route.query.examinationType,
            examination_id: this.$route.query.examination_id,
          },
          (data) => {
            this.paperType = this.filterPaperName(
              data.titleTrans ? JSON.parse(data.titleTrans) : ''
            )
            this.examType = data.levelName
            let mixpanelParams = {
              paper_type: this.paperType,
              exam_type: this.examType,
            }
            analytics.logEvent('hskweb_mockexam_view', mixpanelParams)
            // 试卷引导音频
            this.explainAudio = data.explainAudio
            // 获取资源index.json文件
            this.rootPath = data.resource_url.slice(0, -4) + '/'
            // 拼装环节数组(除听力外预览跟回顾时间都为0)
            this.partProgressList = data.segments.map((item) => {
              return {
                segmentCode: item.segmentCode,

                duration:
                  item.segmentCode == 'listen'
                    ? -1
                    : this.getAnsTimes(data.segments, item.segmentCode) * 60 * 1000,
                previewTime: item.segmentCode == 'listen' ? -1 : 0,
                reviewTime:
                  item.segmentCode == 'listen' ? data.listenReviewDuration * 60 * 1000 : 0,
                questionCount: item.questionCount,
              }
            })
            this.titleTrans = JSON.parse(data.titleTrans)
            resolve()
          }
        )
      })
    },
    // 获取索引页数据
    getQuesList() {
      window.utilV2.getJSON(`${this.rootPath}index.json`, (data) => {
        this.resourceList = []
        // 重新组装索引页数据（整套试卷的数据）
        let tempArr = []
        // 试卷数据
        let Data = []
        for (let i = 0; i < data.items.length; i++) {
          if (tempArr.indexOf(data.items[i].segment_code) === -1) {
            Data.push({
              name: data.items[i].segment_code,
              nameStr: this.findSegmentCodeStr(data.items[i].segment_code),
              dataInfo: [data.items[i]],
            })
            tempArr.push(data.items[i].segment_code)
          } else {
            for (let j = 0; j < Data.length; j++) {
              if (Data[j].name == data.items[i].segment_code) {
                Data[j].dataInfo.push(data.items[i])
                break
              }
            }
          }
        }
        console.log('Data', Data)
        // 取出所有题型的题目 再次重新拼凑
        let quesList = []
        // 记录大题序号
        let bigIndex = 0
        Data.forEach((itemData) => {
          itemData.dataInfo.forEach((data) => {
            quesList.push(this.apiRequest(data.topic_items))
          })
        })
        Promise.all(quesList).then((res) => {
          console.log('res', res)
          let i = 0
          Data.forEach((text) => {
            text.dataInfo.forEach((data) => {
              let fnlData = []
              const { topic_type, part_code, segment_code } = data
              for (let j = 0; j < res[i].length; j++) {
                bigIndex++
                if (res[i][j].questions) {
                  for (let k = 0; k < res[i][j].questions.length; k++) {
                    const { questions, listen, screen_text, config } = res[i][j]
                    let deepQuestion = JSON.parse(JSON.stringify(questions))
                    Object.assign(res[i][j].questions[k], {
                      topic_type,
                      questions: deepQuestion,
                      part_code,
                      segment_code,
                      ifGroup: true,
                      num: questions.length - k,
                      nnum: k + 1,
                      bigIndex,
                      top_listen: listen,
                      top_screen_text: screen_text,
                      config,
                    })
                    fnlData.push(res[i][j].questions[k])
                  }
                  bigIndex += res[i][j].questions.length - 1
                } else {
                  Object.assign(res[i][j], {
                    topic_type,
                    part_code,
                    segment_code,
                    ifGroup: false,
                    num: 1,
                    nnum: 1,
                    bigIndex,
                  })
                  fnlData.push(res[i][j])
                }
              }
              i++
              data.questionList = fnlData
              // 过滤需要批改的作业
              if (Object.values(MARK_RESULT_TYPE).includes(topic_type)) {
                this.markIdList.push(
                  ...fnlData.filter((e) => !e.is_example).map((qItem) => qItem.index)
                )
              }
            })
          })
          console.log('组装完的数据', Data)
          this.resourceList = Data
          console.log(this.markIdList)

          // 获取每个题型有几个音频（如果题干有音频则加到这组题中第一个）
          this.resourceList.forEach((item) => {
            if (item.name == 'listen') {
              item.dataInfo.forEach((data) => {
                data.questionList.forEach((qus) => {
                  let i = 0
                  let obj = {
                    audio_text: '',
                    audio_url: '',
                    index: qus.index || '',
                    is_stem: false, // 题干
                    is_example: qus.is_example || false,
                  }
                  let objs = []
                  if (qus.top_listen && qus.nnum == 1) {
                    i++
                    obj.audio_text = qus.top_listen.audio_text
                    obj.audio_url = qus.top_listen.audio_file
                    obj.is_stem = true
                    objs.push({ ...obj })
                  }
                  if (qus.listen) {
                    i++
                    obj.audio_text = qus.listen.audio_text
                    obj.audio_url = qus.listen.audio_file
                    obj.is_stem = false
                    objs.push({ ...obj })
                  }
                  if (qus.content) {
                    i++
                    obj.audio_text = qus.content_sentence
                    obj.audio_url = qus.content
                    obj.is_stem = false
                    objs.push({ ...obj })
                  }
                  this.listenNumList.push(i)
                  this.listenAllList = [...this.listenAllList, ...objs]
                })
              })
              this.listenAllList = this.listenAllList.map((item, index) => ({
                ...item,
                count: index,
              }))
            }
          })
          console.log('listenNumList', this.listenNumList)
          // 不是答题模式时
          if (this.$route.query.paperStatus == 1) {
            this.isShowCountDown = false
            this.getFinishedRes()
          } else {
            // 答题模式-过程中刷新页面或者继续作答入口进入的，examination_id参数对于新作答的页面url中是没有的
            // 继续考试
            if (Number(this.$route.query.ansStatus) || this.$route.query.examination_id) {
              if (sessionStorage.onbeforeunload === 'simulation') {
                sessionStorage.removeItem('onbeforeunload')
                window.layer.open({
                  title: '',
                  closeBtn: 0,
                  content: this.$t('hsk_if_test'),
                  yes: (index) => {
                    // 点击继续考试
                    analytics.logEvent('hskweb_mockClick_continueExamBtn', {})
                    this.continueTest() // 继续考试
                    window.layer.close(index)
                  },
                })
              } else {
                this.continueTest() // 继续考试
              }
              // 重新作答或者开始作答的
            } else {
              this.initExaminationPaper()
            }
          }
        })
      })
    },
    // 初始化试卷状态
    initExaminationPaper() {
      const { query } = this.$route
      // 作业为4 试卷为2
      utilV2.postData(
        +query.examinationType === 4
          ? ApiPath.home_work_init_paper
          : ApiPath.hsk_init_emulation_paper,
        +query.examinationType === 4
          ? { assignment_id: query.assignment_id }
          : {
              paperId: query.paperId,
              examinationType: +query.examinationType,
              mock_type: query.mock_type,
            },
        (data) => {
          // console.log('初始化试卷状态', data)
          // 获取试卷id
          this.examId = data.examination_id || data
          if (window.location.href.indexOf('examination_id') == -1) {
            window.history.replaceState(
              {},
              '',
              window.location.href + `&examination_id=${data.examination_id || data}`
            )
          } else if (!getQueryString('examination_id')) {
            window.history.replaceState(
              {},
              '',
              changeURLArg('examination_id', data.examination_id || data)
            )
          }
          // 开始播放音频\取第一个题目
          console.log('this.resourceList', this.resourceList)
          console.log('this.partProgressList', this.partProgressList)
          this.time = this.partProgressList[0].previewTime
          // this.$refs.progress.previewVisible = true
          this.$player.play(this.explainAudio)
          this.$player.onended = () => {
            // 预览音频结束后初始化题目index
            this.$refs.progress.currentQuesIndex = 1
            this.$refs.progress.previewVisible = false
            this.$refs.progress.finish('init')
          }
          this.$refs.progress.selectQues()
          // 初始化完成进入
        },
        (data) => {
          if (data.errcode == 3004) {
            this.paperOff = true
            this.$message.warning(this.$t('test_paper_office'))
            this.$router.back(-1)
          } else if (data.errcode == 3001) {
            this.paperOff = true
            this.$message.warning(this.$t(data.errmsg))
            this.$router.back(-1)
          } else {
            this.paperOff = true
            this.$message.warning(data?.message)
            this.$router.back(-1)
          }
        }
      )
    },
    // 继续考试
    continueTest() {
      const { query } = this.$route
      utilV2.postData(ApiPath.hsk_get_list_answer, { ...query }, (data) => {
        console.log('data', data)
        let continueCode = data.segmentCode
        this.answerNotesArray = data.questionAnswers
        this.writeIsBegin = data.abbreviationState
        // 设置为作答阶段
        this.$refs.progress.ansProgressStatus = 1
        if (continueCode == 'listen') {
          this.$refs.progress.currentVoiceIndex = data.audioIndex
          this.$refs.progress.currentQuesIndex = this.getQuesListIndexForVoice(
            this.$refs.progress.currentVoiceIndex
          )
          console.log(this.$refs.progress.currentQuesIndex)
        }
        // 得到记录合并对象
        // console.log('resourceList', this.resourceList)
        let j = 0
        // console.log(this.answerNotesArray)
        this.answerNotesArray.length &&
          this.resourceList.forEach((item) => {
            item.dataInfo.forEach((type) => {
              for (let i = 0; i < type.questionList.length; i++) {
                if (type.questionList[i].is_example) continue
                Object.assign(type.questionList[i], this.answerNotesArray[j])
                // 需要些额外的信息，后端没存进去在这里合并
                Object.assign(this.answerNotesArray[j], {
                  ifGroup: type.questionList[i].ifGroup,
                  num: type.questionList[i].num,
                  nnum: type.questionList[i].nnum,
                  count: type.questionList[i].count,
                })
                if (
                  !this.isFirstQuestion &&
                  this.answerNotesArray &&
                  !this.answerNotesArray[j].answer &&
                  continueCode != 'listen' &&
                  type.questionList[i].segment_code == continueCode
                ) {
                  // 非听力找出第一个未作答的题
                  this.$refs.progress.currentVoiceIndex = this.$refs.progress.currentQuesIndex =
                    this.answerNotesArray[j].count + 1
                  this.isFirstQuestion = true
                }
                j++
              }
            })
          })
        //  如果没有找到当前环节第一个未作答的题,则定位到当前环节最后一个题
        if (!this.isFirstQuestion && continueCode != 'listen') {
          const continueCodeArr = this.answerNotesArray.filter(
            (fil) => fil.segmentCode === continueCode
          )
          const continueCodeLast = continueCodeArr[continueCodeArr.length - 1]
          console.log('continueCodeLast: ', continueCodeLast)

          this.$refs.progress.currentVoiceIndex = this.$refs.progress.currentQuesIndex =
            continueCodeLast.count + 1
        }
        /**
         * 非听力部分重新赋值accumulationNum属性给子组件
         * getNumsBeforeCurrentSegmentCode为子组件中的方法，此方法对data.questionAnswers中的数据进行了扁平化处理，如果听力题中存在套题直接操作data.questionAnswers计数有误
         */
        if (continueCode !== 'listen') {
          this.$refs.progress.accumulationNum =
            this.$refs.progress.getNumsBeforeCurrentSegmentCode(continueCode) ||
            data.questionAnswers.find((item) => item.segmentCode === continueCode).count + 1
        }
        this.$nextTick(() => {
          this.$refs.progress.selectQues()
          let partProgress = this.partProgressList.find((item) => {
            return item.segmentCode == this.currItem.segment_code
          })
          this.time =
            continueCode == 'listen'
              ? -1
              : data.countDown == -1
              ? partProgress.duration
              : data.countDown // 继续上次作答时间
          setTimeout(() => {
            continueCode != 'listen' && this.$refs.progress.$refs.countDown.start()
          })
        })
      })
    },
    // 请求每个题的json数据
    apiRequest(name) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve) => {
        let result
        await utilV2.getJSON(`${this.rootPath + name}`, (data) => {
          result = data.items
        })
        resolve(result)
      })
    },
    //根据segment_code返回多语言
    findSegmentCodeStr(code) {
      let codeStr = ''
      switch (code) {
        case 'listen':
          codeStr = this.$t('hsk_listen_name')
          break
        case 'read':
          codeStr = this.$t('hsk_read_name')
          break
        case 'write':
          codeStr = this.$t('hsk_write_name')
          break

        default:
          break
      }
      return codeStr
    },
    filterPaperName(nameTrans) {
      let language = localStorage.getItem('language')
      if (language === 'zh') {
        language = 'cn'
      }

      return nameTrans[language]
    },
    changeProgressStatus(val) {
      this.ansProgressStatus = val
    },
    // 提供给子组件改变时间用
    changeTime(val) {
      let partProgress = this.partProgressList.find((item) => {
        return item.segmentCode == this.currItem.segment_code
      })
      // console.log('val', val)
      // console.log('partProgress', partProgress)
      // this.time = val == 1 ? 10000 : 10000
      this.time = val == 1 ? partProgress.duration : partProgress.reviewTime
      if (this.$refs.progress.ansProgressStatus == 2) {
        this.showButtonPlay = true
        this.showButtonPause = false
      }
      if (this.time > 0) {
        this.$nextTick(() => {
          this.$refs.progress.$refs.countDown.reset()
          this.$refs.progress.$refs.countDown.start()
        })
      } else {
        this.$refs.progress.selectQues()
      }
    },
    // 1选择答题卡后执行的 2 首次进入也会执行 3 继续考试也会走
    currentSelect(obj) {
      console.log('选择答题卡 currentSelect ', obj)
      this.$store.dispatch('setPartForAudio', { part: obj.segment_code })
      // 既兼容老资源格式也兼容新的
      this.currItem = obj.listen ? { ...obj, content: obj.listen.audio_file } : { ...obj }
      // 兼容新资源格式
      let isListenGroup =
        obj.topic_type == 'ea' &&
        obj.questions.find((item) => item.listen && item.listen.audio_file)
      if (
        obj.segment_code == 'listen' &&
        obj.topic_type != 'xt' &&
        obj.topic_type != 'lt' &&
        !isListenGroup
      ) {
        if (this.$route.query.paperStatus != 1) {
          setTimeout(() => {
            // 初始化成第一题
            // this.currentQuesIndex = this.currentVoiceIndex
            // 如果选择答题卡切换题目时,不自动播放切换题的音频
            if (
              this.$refs.progress.currentVoiceIndex == this.$refs.progress.currentQuesIndex &&
              this.$refs.progress.ansProgressStatus == 1 &&
              !this.videoPlayList[this.$refs.progress.currentQuesIndex]
            ) {
              this.playAudio()
              this.videoPlayList[this.$refs.progress.currentQuesIndex] = true
            }
          }, 400)
        }
      } else if (
        (obj.topic_type == 'xt' || obj.topic_type == 'lt' || isListenGroup) &&
        this.$route.query.paperStatus != 1
      ) {
        console.log(23232323)
        console.log(this.$refs.progress.currentVoiceIndex,this.$refs.progress.currentQuesIndex,this.$refs.progress.ansProgressStatus,this.videoPlayList[this.$refs.progress.currentVoiceIndex])
        this.showButtonPlay = false
        this.showButtonPause = false
        this.$nextTick(() => {
          if (
            this.getQuesListIndexForVoice(this.$refs.progress.currentVoiceIndex) ==
              this.$refs.progress.currentQuesIndex &&
            this.$refs.progress.ansProgressStatus == 1 &&
            !this.videoPlayList[this.$refs.progress.currentVoiceIndex]
          ) {
            // 满足此条件说需要播放听力的题干
            console.log('播放听力的index', this.$refs.progress.currentVoiceIndex)
            if (
              this.listenNumList[this.$refs.progress.currentQuesIndex - 1] > 1 &&
              this.getQuesListIndexForVoice(this.$refs.progress.currentVoiceIndex) !==
                this.getQuesListIndexForVoice(this.$refs.progress.currentVoiceIndex - 1)
            ) {
              // this.$refs.progress.currentQuesIndex = null
              this.$refs.componentRef.autoPlay(obj, true)
            } else {
              this.$refs.componentRef.autoPlay(obj, false)
            }
            this.videoPlayList[this.$refs.progress.currentVoiceIndex] = true
          }
        })
      } else {
        this.showButtonPlay = false
        this.showButtonPause = false
      }
    },
    //点击播放音频与自动播放音频
    playAudio(isTryAgain) {
      console.log('playAudio,')
      // console.log('bo放音频:  ', isTryAgain)
      this.showButtonPlay = false
      this.showButtonPause = true
      const _this = this
      let audioPath = this.rootPath + this.currItem.content
      this.$player.play(audioPath, '', {}, isTryAgain)
      this.$player.onended = (e) => {
        // console.log('bo放音频:  onended')
        if (_this.isExamMode) {
          if (e == 'failed') {
            _this.playVoiceTime = 0
            layer.open({
              title: '',
              closeBtn: 0,
              content: _this.$t('common_video_failed'),
              btn: [_this.$t('button_common_start_over'), _this.$t('hsk_skip')],
              yes: (index) => {
                _this.randomData = new Date().getTime()
                _this.playAudio(true)
                layer.close(index)
              },
              btn2: (index) => {
                _this.changeIndex()
                layer.close(index)
              },
            })
            _this.showButtonPlay = true
            _this.showButtonPause = false
          } else {
            setTimeout(() => {
              if (this.currItem.segment_code === 'listen' && !this.playerPaused) {
                _this.playVoiceTime = 0
                _this.showButtonPlay = true
                _this.showButtonPause = false
                _this.changeIndex()
              }
            }, VOICE_EXTEND_TIME * 1000)
          }
        } else {
          _this.showButtonPlay = true
          _this.showButtonPause = false
        }
      }
      this.$player.onloaded = (e) => {
        // console.log('bo放音频:  onloaded', e)
        if (!e) return
        this.playVoiceTime = e + VOICE_EXTEND_TIME
        // console.log('playVoiceTime', this.playVoiceTime)
      }
    },
    //点击暂停音频
    pauseAudio() {
      this.$player.pause()
      this.showButtonPlay = true
      this.showButtonPause = false
    },
    //停止播放音频
    playStop() {
      if (
        this.currItem.segment_code == 'listen' &&
        this.currItem.topic_type != 'xt' &&
        this.currItem.topic_type != 'lt'
      ) {
        this.$player.stop()
        this.showButtonPlay = true
        this.showButtonPause = false
      } else if (this.currItem.topic_type == 'xt' || this.currItem.topic_type == 'lt') {
        this.$player.stop()
        this.showButtonPlay = false
        this.showButtonPause = false
      }
    },
    // 保存做完的题目
    saveRes(obj) {
      this.answerObject = obj
    },
    // 改变音频index以及题目index(只有听力才走此方法)
    changeIndex() {
      console.log('this.$refs.progress.currentVoiceIndex: ', this.$refs.progress?.currentVoiceIndex)
      analytics.logEvent('hskweb_mockflow_VoiceIndex', {
        index: this.$refs.progress?.currentVoiceIndex || 0,
      })
      if (
        this.$refs.progress &&
        this.searchAnsNumber('listen') ==
          this.getQuesListIndexForVoice(this.$refs.progress.currentVoiceIndex)
      ) {
        this.$refs.progress.ansProgressStatus == 2
        this.$refs.progress.finish('listen')
      } else {
        // this.isExamMode && this.changeIndex()
        // 获取听力一个多少个题（题干带音频算一个）
        let listenLength = 0
        this.listenNumList.forEach((item) => {
          listenLength += item
        })
        // 查询每个题型的数量
        if (this.$refs.progress && this.$refs.progress.currentVoiceIndex < listenLength) {
          this.$refs.progress.currentVoiceIndex++
          // 为了防止播放下一题听力index 对应的 quesindex 与提前点击下一题quesindex 相同导致quesindex watch不到，手动执行下一题
          if (
            this.$refs.progress.currentQuesIndex ==
            this.getQuesListIndexForVoice(this.$refs.progress.currentVoiceIndex)
          ) {
            this.$refs.progress.selectQues('', '', true)
          } else {
            this.$refs.progress.currentQuesIndex = this.getQuesListIndexForVoice(
              this.$refs.progress.currentVoiceIndex
            )
          }
          console.log(this.$refs.progress.currentQuesIndex, this.$refs.progress.currentVoiceIndex)
        }
      }
    },
    // 根据currentVoiceIndex获取当前处于哪个听力题（因有的听力题干包含听力）
    getQuesListIndexForVoice(val) {
      let i = 0
      let sum = 0
      for (let j = 0; j < this.listenNumList.length; j++) {
        i += this.listenNumList[j]
        if (i >= val) {
          sum = j + 1
          break
        }
      }
      return sum
    },
    // 完成后查看做题状态
    getFinishedRes() {
      const { query } = this.$route
      utilV2.postData(ApiPath.hsk_get_list_answer, { ...query }, (data) => {
        console.log(this.resourceList)
        this.answerNotesArray = data.questionAnswers
        this.isMarked = data.mark_status
        console.log(this.answerNotesArray)
        // 得到记录合并对象
        if (this.answerNotesArray.length) {
          this.resourceList.forEach((item) => {
            item.dataInfo.forEach((type) => {
              type.questionList.forEach((eg) => {
                if (eg.index) {
                  this.answerNotesArray[eg.index - 1].nnum = eg.nnum
                  this.answerNotesArray[eg.index - 1].num = eg.num
                  this.answerNotesArray[eg.index - 1].ifGroup = eg.ifGroup
                  // 重新改变judge规则
                  Object.assign(eg, this.answerNotesArray[eg.index - 1], {
                    judge: this.answerNotesArray[eg.index - 1].scores / eg.score >= 0.8 ? 1 : 0,
                  })
                }
              })
            })
          })
        }
        this.$nextTick(() => {
          this.$refs.progress.selectQues()
        })
      })
    },
    // 提交答案改变状态
    submitAnswer() {
      this.isSubmitAnswer = true
    },

    searchAnsNumber(code) {
      let i = 0
      this.resourceList.forEach((item) => {
        if (item.name == code) {
          item.dataInfo.forEach((data) => {
            data.questionList.forEach(() => {
              i++
            })
          })
        }
      })
      return i
    },
    // 根据数据以及code获取当天作答时长
    getAnsTimes(list, code) {
      return list.find((item) => {
        return item.segmentCode == code
      }).duration
    },
    goBack() {
      this.$router.back()
    },
    /** 点击退出登录按钮所以在跳转前调用logout */
    checkLogout() {
      if (this.onClickLogout) {
        this.$store.dispatch('user/handleLogout', { reLogin: false })
      }
    },
  },
  // 离开页面时先保存作答记录
  beforeRouteLeave(to, from, next) {
    analytics.logEvent('hskweb_mockClick_beforeRouteLeave', {
      to: to.fullPath,
      from: from.fullPath,
    })
    // ...
    if (
      this.isSubmitAnswer ||
      this.$route.query.paperStatus == 1 ||
      this.paperOff ||
      !this.isLogin
    ) {
      window.onbeforeunload = null
      next()
      this.playStop()
    } else {
      this.$store.dispatch('notifLogout', false)
      let token = getToken()
      backLayerHandler(
        async () => {
          // 确定后执行的操作
          let mixpanelParams = {
            paper_type: this.paperType,
            exam_type: this.examType,
          }
          analytics.logEvent('hskweb_examquit_click', mixpanelParams)
          this.$refs.progress.$refs.countDown && this.$refs.progress.$refs.countDown.pause()
          let status = this.$refs.progress.ansProgressStatus != 2
          this.playStop()
          localStorage.removeItem('bigIndex')
          token && (await this.$refs.progress.saveApiRequest('', status))
          this.checkLogout()
          window.onbeforeunload = null
          await next()
        },
        {
          type: 'default',
          msg: token ? this.$t('hsk_if_save') : this.$t('hsk_login_filed'),
          cancel: () => {
            //取消阻止本次返回跳转，回归到本页面url
            this.onClickLogout = false
            next(false)
          },
        }
      )
    }
  },
  beforeDestory() {
    window.onbeforeunload = null
    this.$player.onloaderrored = null
    this.$player.onplayerrored = null
  },
}
</script>

<style lang="scss" scoped>
::v-deep.el-dialog__footer {
  padding: 0;
}
::v-deep.el-dialog__header {
  padding: 0;
}
.dialog-footer {
  display: flex;
  align-items: center;
  border-top: 1px solid #f2f3f5;
  span {
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 59px;
    cursor: pointer;
    &:first-child {
      border-right: 1px solid #f2f3f5;
    }
  }
}
.page-back {
  margin: 0 0 12px 98px;
  cursor: pointer;
  .desc {
    color: #2c2f46;
    font-family: 'Inter';
    font-weight: 500;
    font-size: 12px;
  }
}
</style>
